// extracted by mini-css-extract-plugin
export default {"background":"modal_background__tagHt","triLeft":"modal_triLeft__6aJyr","triRight":"modal_triRight__ASpss"};